module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_3.88ffb0ce.png";